import React from 'react';
import { motion } from 'framer-motion';

interface LocationTabsProps {
  activeLocation: 'puerto-la-cruz' | 'margarita';
  onLocationChange: (location: 'puerto-la-cruz' | 'margarita') => void;
}

const LocationTabs: React.FC<LocationTabsProps> = ({ activeLocation, onLocationChange }) => {
  return (
    <div className="flex justify-center my-8">
      <div className="bg-dark-lighter rounded-full p-1 flex relative gold-border w-64 md:w-80">
        <button
          onClick={() => onLocationChange('puerto-la-cruz')}
          className={`relative z-10 px-4 py-2 rounded-full transition-colors flex-1 text-center ${
            activeLocation === 'puerto-la-cruz' ? 'text-dark font-medium' : 'text-gold'
          }`}
        >
          Puerto la Cruz
        </button>
        <button
          onClick={() => onLocationChange('margarita')}
          className={`relative z-10 px-4 py-2 rounded-full transition-colors flex-1 text-center ${
            activeLocation === 'margarita' ? 'text-dark font-medium' : 'text-gold'
          }`}
        >
          Margarita
        </button>
        {activeLocation === 'puerto-la-cruz' ? (
          <motion.div
            className="absolute top-1 left-1 bg-gold rounded-full"
            layoutId="tab-background"
            initial={false}
            transition={{ type: 'spring', duration: 0.6 }}
            style={{ width: 'calc(50% - 2px)', height: 'calc(100% - 2px)' }}
          />
        ) : (
          <motion.div
            className="absolute top-1 right-1 bg-gold rounded-full"
            layoutId="tab-background"
            initial={false}
            transition={{ type: 'spring', duration: 0.6 }}
            style={{ width: 'calc(50% - 2px)', height: 'calc(100% - 2px)' }}
          />
        )}
      </div>
    </div>
  );
};

export default LocationTabs;
